<template>
    <b-container>
        <b-row class="justify-content-center">
            <b-col cols="12" md="12" class="mb-3">
                Inserisci qui di seguito i dati relativi al referente.<br>
                Il referente sarà la persona responsabile della gestione del profilo e
                sarà il punto di contatto tra il nostro staff e la società.
            </b-col>
            <b-col cols="12" md="6">
                <inter-input class="mb-3"
                             label="Nome "
                             v-model="referente.name"
                             :error="errors.name"
                             icon="group">
                </inter-input>
            </b-col>
            <b-col cols="12" md="6">
                <inter-input class="mb-3"
                             label="Cognome"
                             v-model="referente.surname"
                             :error="errors.surname"
                             icon="group">
                </inter-input>
            </b-col>
            <b-col cols="12" md="7">
                <inter-input class="mb-3"
                             label="Email"
                             v-model="referente.email"
                             :error="errors.email"
                             icon="mail">
                </inter-input>
            </b-col>
            <b-col cols="12" md="5">
                <inter-input class="mb-3"
                             label="Telefono"
                             v-model="referente.phone"
                             :error="errors.phone"
                             icon="phone-call">
                </inter-input>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    import InterInput from "../../../../components/form/inter-input/InterInput";
    import Utils from '@/utils';
    import _ from "lodash";

    export default {
        name: "RegisterWizardStepThree",
        components: {InterInput},
        props: {
            referente: {
                type: Object,
                default: () => {}
            }
        },
        data() {
            return {
                errors:{}
            }
        },
        methods: {

            validate: function () {

                this.errors = {};
                if(this.referente.name === '') {
                    this.errors.name = true;
                }
                if(this.referente.surname === '') {
                    this.errors.surname = true;
                }
                if(this.referente.phone === '') {
                    this.errors.phone = true;
                }
                if(this.referente.email === '') {
                    this.errors.email = true;
                }

                if(!Utils.validateEmail(this.referente.email)) {
                    this.errors.email = true;
                }

                if(!Utils.validatePhone(this.referente.phone)) {
                    this.errors.phone = true;
                }

                if (_.isEmpty(this.errors)) {
                    return true;
                } else {
                    this.$bvToast.toast('Mi manca qualche dato', {
                        title: 'Alert',
                        variant: 'warning'
                    });
                    return false;
                }

            },
        }
    }
</script>

<style scoped>

</style>
